<template>
	<div class="calculator__radio">
		<div class="mdc-form-field">
			<div class="mdc-radio">
				<input
					:id="`${name}-${value}`"
					:value="value"
					:name="name"
					:checked="checked"
					:disabled="disabled"
					:required="required"
					:data-form-error="`#${name}-error`"
					class="mdc-radio__native-control"
					type="radio"
				/>
				<div class="mdc-radio__background">
					<div class="mdc-radio__outer-circle"></div>
					<div class="mdc-radio__inner-circle"></div>
				</div>
			</div>
			<label :for="`${name}-${value}`">{{ label }}</label>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Radio',
	props: {
		name: String,
		label: String,
		checked: Boolean,
		disabled: Boolean,
		required: Boolean,
		value: String
	},
	mounted() {
		if (window.LN && window.LN.initCustomFields) {
			window.LN.initCustomFields(this.$el);
		}
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__radio {
	display: inline-block;
}
.calculator__radio + .calculator__radio {
	margin-left: 24px;
}
</style>
